// export const API_BASE_URL = 'http://127.0.0.1:8080/api';
export const API_BASE_URL = 'api';

export const DONATE_LINK = 'https://www.paypal.com/donate/?hosted_button_id=9R7DXG8WPN3G8';
export const OBSCURE_STRING = 'njoxcenijcbgeiyfgiebxjownxojhgerifgierhbclwnorhfzpqnvbr';